import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

jQuery(document).ready(function($) {  
    if ($('#posts-container').length > 0) {
        var InfiniteScroll = function() {
            this.currentPage = 1;
            this.maxPages = $('#number-pages').data('pages');
            this.loading = false;
            this.button = $('#load-more-button');
            this.postsContainer = $('#posts-container');

            this.init = function() {
                var self = this;
                self.bindEvents();
            };

            this.bindEvents = function() {
                var self = this;

                $(window).on('scroll', function() {
                    var buttonOffset = self.button.offset().top;
                    var windowHeight = $(window).height();
                    var scrollPosition = $(window).scrollTop();

                    if (scrollPosition + windowHeight >= buttonOffset) {
                        self.loadMorePosts();
                    }
                });
            };

            this.loadMorePosts = function() {
                var self = this;

                if (self.currentPage < self.maxPages && !self.loading) {
                    self.loading = true;
                    self.currentPage++;

                    var data = {
                        'action': 'load_more_posts',
                        'page': self.currentPage,
                        'query_vars': '<?php echo json_encode($args); ?>',
                    };

                    $.ajax({
                        url: ajaxurl,
                        type: 'post',
                        data: data,
                        success: function(response) {
                            var newPosts = $(response).addClass('animate-transition');
                            self.postsContainer.append(newPosts);
                            
                            // Forçar um repaint para que a transição seja aplicada
                            newPosts[0].offsetHeight;
                            
                            // Adicionar classe 'visible' para tornar a transição visível
                            newPosts.addClass('visible');
                            
                            self.loading = false;

                            if (self.currentPage >= self.maxPages) {
                                self.button.addClass('d-none');
                            } else {
                                self.button.removeClass('d-none');
                            }

                            ScrollTrigger.refresh();
                        }
                    });
                }
            };
        };

        var infiniteScroll = new InfiniteScroll();
        infiniteScroll.init();
    }
});
